<template>
  <Sidebar
    :visible.sync="isSidebarMapDataOpenLocal"
    :base-z-index="1000"
    position="right"
    class="w-full md:w-100rem lg:w-110rem"
    style="background: #f8f8f8; border-left: 2px solid #cad2d6; width: 30rem"
    @hide="closeSidebar"
  >
    <div class="reviews-sidebar-map-data-container">
      <div class="reviews-sidebar-map-data-header">
        <img src="/pin-map.svg" alt="Map Icone" />
        <span class="reviews-sidebar-map-data-header-title">{{ name }}</span>
      </div>
      <TotalReview :reviewData="reviewData" />
      <GoogleReview :reviewData="reviewData" />
    </div>
  </Sidebar>
</template>

<script>
import Sidebar from 'primevue/sidebar'
import TotalReview from '../TotalReview/TotalReview'
import GoogleReview from '../GoogleReview/GoogleReview'
export default {
  props: {
    isSidebarMapDataOpen: Boolean,
    reviewData: Object,
  },
  components: {
    Sidebar,
    TotalReview,
    GoogleReview,
  },
  data() {
    return {
      isSidebarMapDataOpenLocal: this.isSidebarMapDataOpen,
      name: '',
    }
  },
  methods: {
    closeSidebar() {
      this.isSidebarMapDataOpenLocal = false
      this.$emit('update:isSidebarMapDataOpen', false)
    },
  },
  watch: {
    isSidebarMapDataOpen: {
      handler(data) {
        this.isSidebarMapDataOpenLocal = data
      },
      immediate: true,
    },
    reviewData: {
      handler(data) {
        this.name = this.reviewData?.name
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
